export function getDynamicTitle(path: string): string {
  const p = path.toLowerCase();

  if (p.startsWith('/register') && p.includes('personid') && p.includes('guid')) return 'My Membership';
  if (p === '/register' || p.startsWith('/register?')) return 'Account';

  if (p.startsWith('/match_detail')) return 'Match Review';

  if (p.startsWith('/how')) return 'Learn How';

  if (p.startsWith('/info') && p.includes('action=debug_dump')) return 'Debug Dump';

  if (p.startsWith('/doc') && p.includes('tsandcs')) return 'Terms & Conditions';
  if (p.startsWith('/doc') && p.includes('privacy_policy')) return 'Privacy Policy';
  if (p.startsWith('/doc') && p.includes('cookies')) return 'Cookie Policy';

  if (p.startsWith('/player_detail')) return 'Profile';
  if (p.startsWith('/player_admin')) return 'Player Admin';

  if (p.startsWith('/dashboard') && p.includes('tab=feed')) return 'Feed';
  if (p.startsWith('/dashboard') && p.includes('tab=community')) return 'Communities';
  if (p.startsWith('/dashboard') && p.includes('tab=insights')) return 'Insights';

  if (p.startsWith('/clubs')) return 'Club Details';
  if (p.startsWith('/update_club')) return 'Update Club';

  if (p.startsWith('/config') && p.includes('email_config')) return 'Control Centre';

  if (p.startsWith('/subscribe') && p.includes('add_payment_method')) return 'Payment Methods';

  if (p.startsWith('/following')) return 'Following';

  if (p.startsWith('/most_improved')) return 'Most Improved';

  if (p.startsWith('/boxes') && p.includes('help')) return 'Boxes Help';

  if (p.startsWith('/timer') && !p.includes('testtype=')) return 'Timer';
  if (p.startsWith('/skillstest_detail') && p.includes('testname')) return 'Test Info';
  if (p.startsWith('/timer') && p.includes('testtype=')) return 'Take Test';
  if (p.startsWith('/skillstest_results') && p.includes('testname')) return 'Enter your score';

  if (p.startsWith('/get_connected')) return 'Get Connected';
  if (p.startsWith('/club_membership')) return 'Club Membership';
  if (p.startsWith('/subscribe_thanks')) return 'Thank You!';
  if (p.startsWith('/register_verify')) return 'Email Verification';
  if (p.startsWith('/register_thanks')) return 'Welcome!';
  if (p.startsWith('/welcome_aboard')) return 'Welcome!';
  if (p.startsWith('/register') && p.includes('promotion')) return 'Win!';
  if (p.startsWith('/register') && p.includes('transition')) return 'Update Membership';

  return '';
};